import React from 'react'
import { formatDate } from '@/v2/utils/dateHelpers'
import { currency } from '@/v2/utils/format'
import PerformanceTable from './PerformanceTable'
import { TableCell, Badge, MetricChange } from '../styles'

const WeeklyPerformanceTable = ({ data, onExport }) => {
  const headers = [
    { label: 'Week' },
    { label: 'Bookings', tooltip: 'Total appointments scheduled' },
    { label: 'Showed', tooltip: 'Patients who attended' },
    { label: 'No-Shows', tooltip: 'Patients who missed appointments' },
    { label: 'Show Rate', tooltip: 'Percentage of patients who showed up' },
    { label: 'Starts', tooltip: 'Patients who began treatment' },
    { label: 'Revenue', tooltip: 'Total revenue generated' },
    { label: 'Conv %', tooltip: 'Starts ÷ Bookings × 100' },
  ]

  const renderRow = week => {
    const showRate =
      week.show_rate ??
      (week.bookings > 0
        ? ((week.showed_up / week.bookings) * 100).toFixed(1)
        : 0)
    const conversion =
      week.conversion_rate ??
      (week.bookings > 0 ? ((week.starts / week.bookings) * 100).toFixed(1) : 0)

    return (
      <>
        <TableCell>{formatDate(week.week_start, 'MMM dd, yyyy')}</TableCell>
        <TableCell>{week.bookings}</TableCell>
        <TableCell>{week.showed_up}</TableCell>
        <TableCell>{week.no_shows}</TableCell>
        <TableCell>
          <Badge
            label={`${showRate}%`}
            color={
              showRate >= 80 ? 'success' : showRate >= 60 ? 'warning' : 'error'
            }
            size="small"
          />
        </TableCell>
        <TableCell>
          <Badge label={week.starts} color="primary" size="small" />
        </TableCell>
        <TableCell>
          <span style={{ fontWeight: 600, color: '#05AD48' }}>
            {currency(week.revenue || 0)}
          </span>
        </TableCell>
        <TableCell>
          <MetricChange $positive={conversion > 30}>{conversion}%</MetricChange>
        </TableCell>
      </>
    )
  }

  return (
    <PerformanceTable
      title="Weekly Performance"
      subtitle="Week-by-week breakdown of appointments, attendance, and treatment starts"
      chipLabel={`${data?.length || 0} weeks`}
      onExport={onExport}
      headers={headers}
      data={data}
      renderRow={renderRow}
      emptyMessage="No weekly data available"
    />
  )
}

export default WeeklyPerformanceTable
